import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "notification-token"
  static values = {
    android: Boolean,
  }

  connect() {
    super.connect()

    this.send("connect", {}, message => {
      const token = message.data.token
      const kind = this.androidValue ? 'android' : 'ios'

      fetch('/api/v1/notification_tokens', {
        body: JSON.stringify({ token, enabled: true, kind }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
    })
  }
}
